// Me store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  blocks: null,
  fields: null,
  types: {},
  module: {
    blog: {
      data: {},
      content: [],
      blocks: [],
    },
    news: {},
    press: {},
    page: {},
    branch: {},
    reference: {},
    structure: {},
  },
};

export default {
  actions,
  mutations,
  state,
  getters,
};
